import EventBus from './eventBus';

window.EventBus = new EventBus();
